<template lang="pug">
el-collapse#empresa-bloco-inserir-contrato-originacao-manualmente
    el-collapse-item(name='cadastroManual')
        h2.cadastro-contrato-originacao__subtitulo(slot='title') {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.titulo') }}

        el-card(:body-style='{ padding: "20px" }', shadow='never')
            el-form.col-12(
                label-position='top',
                :model='formCadastroManual',
                :rules='formCadastroManualRegras',
                ref='formCadastroManualRef'
            )
                .row
                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.numeroContrato")',
                        prop='numeroContrato'
                    )
                        el-input#numeroContrato(
                            v-if='getTrading === "VITERRA"',
                            :value='formCadastroManual.numeroContrato',
                            @input='formatarNumeroContrato',
                            placeholder='0000001-100',
                            maxlength='11'
                        )

                        el-input#numeroContrato(
                            v-else-if='getTrading === "COFCO"',
                            :value='formCadastroManual.numeroContrato',
                            @input='formatarNumeroContrato',
                            placeholder='0000000000',
                            maxlength='10'
                        )

                        el-input#numeroContrato(
                            v-else-if='getTrading === "BE8"',
                            :value='formCadastroManual.numeroContrato',
                            @input='limparNumeroContrato',
                            placeholder='1000100000',
                            maxlength='10',
                            inputmode='numeric'
                        )
                        el-input#numeroContrato(
                            v-else,
                            :value='formCadastroManual.numeroContrato',
                            @input='limparNumeroContrato',
                            placeholder='1000100000',
                            maxlength='10',
                            inputmode='numeric'
                        )
                    el-form-item.col-2(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.cultura")',
                        prop='cultura'
                    )
                        el-select#cultura(
                            v-model='formCadastroManual.cultura',
                            :loading='loading.culturas',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id }, index) in opcoes.culturas',
                                :key='id + nome',
                                :id='"cultura-" + index',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-1(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.safra")',
                        prop='safra'
                    )
                        el-select#safra(
                            v-model='formCadastroManual.safra',
                            :loading='loading.safras',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ ano, id }, index) in opcoes.safras',
                                :key='id + ano',
                                :id='"safra-" + index',
                                :label='ano',
                                :value='id'
                            )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeContratado")',
                        prop='volumeContratado'
                    )
                        el-input#volumeContratado(
                            v-model='formCadastroManual.volumeContratado'
                        )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeRecebido")',
                        prop='volumeRecebido'
                    )
                        el-input#volumeRecebido(
                            v-model='formCadastroManual.volumeRecebido'
                        )
                .row
                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.valorContrato")',
                        prop='valorContrato'
                    )
                        el-input#valorContrato(
                            v-model='formCadastroManual.valorContrato',
                            type='number'
                        )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.dataPagamento")',
                        prop='dataPagamento'
                    )
                        el-date-picker#dataPagamento(
                            v-model='formCadastroManual.dataPagamento',
                            type='date',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            format='dd/MM/yyyy'
                        )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.condicaoFrete")',
                        prop='condicaoFrete'
                    )
                        el-select#condicaoFrete(
                            v-model='formCadastroManual.condicaoFrete',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option#CIF(label='CIF', value='CIF')
                            el-option#FOB(label='FOB', value='FOB')

                    el-form-item.col-3(
                        :label=`formCadastroManual.condicaoFrete ? (formCadastroManual.condicaoFrete === "CIF"
                        ? $t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localDeEntrega")
                        : $t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localDeRetirada"))
                        : $t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localCondicaoFrete")`,
                        prop='localCondicaoFrete'
                    )
                        el-input#localCondicaoFrete(
                            :disabled='!formCadastroManual.condicaoFrete',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            v-model='formCadastroManual.localCondicaoFrete'
                        )

                .row
                    el-form-item.col-1(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.estado")',
                        prop='estado'
                    )
                        el-select#estado(
                            v-model='formCadastroManual.estado',
                            :loading='loading.estados',
                            @change='buscarLocalidadeNivelDois',
                            @clear='buscarLocalidadeNivelDois',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ sigla, id } in opcoes.estados',
                                :key='id + sigla',
                                :id='"estado-" + sigla',
                                :label='sigla',
                                :value='id'
                            )

                    el-form-item.col-2(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localidade")',
                        prop='municipio'
                    )
                        el-select#municipio(
                            v-model='formCadastroManual.municipio',
                            :loading='loading.municipios',
                            :disabled='!formCadastroManual.estado',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoes.municipios',
                                :key='id + nome',
                                :id='"municipio-" + id',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.dataContrato")',
                        prop='dataContrato'
                    )
                        el-date-picker#dataContrato(
                            v-model='formCadastroManual.dataContrato',
                            type='date',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            format='dd/MM/yyyy',
                            :picker-options='pickerOptionsDataContrato'
                        )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.fornecedor")',
                        prop='fornecedor'
                    )
                        el-select#fornecedor(
                            v-model='formCadastroManual.fornecedor',
                            value-key='id',
                            :loading='loading.fornecedor',
                            @change='definirCnpjFornecedor',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='fornecedor in opcoes.fornecedores',
                                :key='fornecedor.id + fornecedor.nome',
                                :id='"fornecedor-" + fornecedor.id',
                                :label='fornecedor.nome',
                                :value='fornecedor'
                            )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.cnpjFornecedor")',
                        prop='cnpjFornecedor'
                    )
                        el-select#cnpjFornecedor(
                            v-model='formCadastroManual.cnpjFornecedor',
                            :disabled='!formCadastroManual.fornecedor',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='(cnpj, index) in opcoes.cnpjFornecedores',
                                :key='cnpj',
                                :id='"cnpjFornecedor-" + index',
                                :label='cnpj',
                                :value='cnpj'
                            )

                .row
                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.segmento")',
                        prop='segmento'
                    )
                        el-select#segmento(
                            v-model='formCadastroManual.segmento',
                            :loading='loading.segmentos',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id, codigo }, index) in opcoes.segmentos',
                                :key='id + nome',
                                :id='"segmento-" + index',
                                :label='`${nome} - ${codigo}`',
                                :value='id'
                            )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.canal")',
                        prop='canal'
                    )
                        el-select#canal(
                            v-model='formCadastroManual.canal',
                            :loading='loading.canais',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id }, index) in opcoes.canais',
                                :key='id + nome',
                                :id='"canal-" + index',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.regional")',
                        prop='regional'
                    )
                        el-select#regional(
                            v-model='formCadastroManual.regional',
                            :loading='loading.regionais',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id }, index) in opcoes.regionais',
                                :key='id + nome',
                                :id='"regional-" + index',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.tipoContrato")',
                        prop='tipoContratoOffline'
                    )
                        el-select#tipoContratoOffline(
                            v-model='formCadastroManual.tipoContratoOffline',
                            :loading='loading.tiposContratoOffline',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='(tipoContrato, index) in opcoes.tiposContratoOffline',
                                :label='tipoContrato',
                                :key='index',
                                :value='tipoContrato'
                            )

                .row
                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.gerenteRegional")',
                        prop='gerenteRegional'
                    )
                        el-select#gerenteRegional(
                            v-model='formCadastroManual.gerenteRegional',
                            :loading='loading.gerentesRegionais',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id }, index) in opcoes.gerentesRegionais',
                                :key='nome + id',
                                :id='"gerenteRegional-" + index',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.gerenteComercial")',
                        prop='gerenteComercial'
                    )
                        el-select#gerenteComercial(
                            v-model='formCadastroManual.gerenteComercial',
                            :loading='loading.gerentesComerciais',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id }, index) in opcoes.gerentesComerciais',
                                :key='nome + id',
                                :id='"gerenteComercial-" + index',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.gestorTerritorial")',
                        prop='gestorTerritorial'
                    )
                        el-select#gestorTerritorial(
                            v-model='formCadastroManual.gestorTerritorial',
                            :loading='loading.gestoresTerritoriais',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id }, index) in opcoes.gestoresTerritoriais',
                                :key='nome + id',
                                :id='"gestorTerritorial-" + index',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-3(label='EUDR', prop='eudr')
                        el-select#contrato-manual-eudr(
                            v-model='formCadastroManual.eudr',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id, value }, index) in opcoes.eudr',
                                :key='`contrato-manual-eu-dr-${index}-${nome}`',
                                :id='`contrato-manual-eu-dr-${index}-${nome}`',
                                :label='nome',
                                :value='value'
                            )

                .row.mt-4
                    .col-btn.w-100.botao-submit
                        el-form-item.col-3
                            el-button#adicionar(
                                type='primary',
                                :disabled='adicionandoContrato',
                                @click='adicionar'
                            )
                                i.el-icon(
                                    :class='adicionandoContrato ? "el-icon-loading" : "el-icon-plus"'
                                )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.adicionarLista') }}
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import RegionalService from '@/services/RegionalService';
import LocalidadeService from '@/services/LocalidadeService';
import PessoaService from '@/services/PessoaService';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import { mapGetters } from 'vuex';

export default {
    name: 'EmpresaBlocoInserirContratoOriginacaoManualmente',
    computed: {
        ...mapGetters(['usuarioLogado', 'trading']),
        getTrading() {
            return this.trading;
        }
    },

    data() {
        const validarNumeroContrato = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            if (this.trading === 'BE8' && value.length < 10) {
                callback(
                    new Error('No mínimo 10 caracteres')
                );
                return;
            }

            if (this.isBunge) {
                if (value.toString().replace(/\D/g, '').length !== 10) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroContrato'
                            )
                        )
                    );
                    return;
                }

                const apenasNumeros = /^\d*$/;
                if (!apenasNumeros.test(value)) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoCaracterNumeroContrato'
                            )
                        )
                    );
                    return;
                }

                if (value.toString().substr(0, 4) !== '1000') {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoInicioNumeroContrato'
                            )
                        )
                    );
                    return;
                }
            }

            callback();
        };

        const validarVolumeContratado = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoVolumeContrato'
                        )
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().endsWith(',')
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                        )
                    )
                );
                return;
            }

            const numeroVirgula = /^[\d,]+$/;
            if (!numeroVirgula.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                        )
                    )
                );
                return;
            }

            // if (parseFloat(value.toString().replace(',', '.')) <= 0) {
            //     callback(
            //         new Error(
            //             this.$t(
            //                 'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorZerado'
            //             )
            //         )
            //     );
            //     return;
            // }

            callback();
        };

        const validarVolumeRecebido = (rule, value, callback) => {
            if (value && value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorComPontos'
                        )
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                (value && maisVirgulas.test(value)) ||
                (value && value.toString().startsWith(',')) ||
                (value && value.toString().endsWith(','))
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                        )
                    )
                );
                return;
            }

            const numeroVirgula = /^[\d,]+$/;
            if (value && !numeroVirgula.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                        )
                    )
                );
                return;
            }

            callback();
        };

        const validarValorContrato = (rule, value, callback) => {
            if (value !== '') {
                if (value.toString().includes('.')) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorComPontos'
                            )
                        )
                    );
                    return;
                }

                const maisVirgulas = /.*,.*,.*/;
                if (
                    maisVirgulas.test(value) ||
                    value.toString().startsWith(',') ||
                    value.toString().endsWith(',')
                ) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                            )
                        )
                    );
                    return;
                }

                const numeroVirgula = /^[\d,]+$/;
                if (!numeroVirgula.test(value)) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                            )
                        )
                    );
                    return;
                }

                if (parseFloat(value.toString().replace(',', '.')) < 0) {
                    callback(
                        new Error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorZerado'
                            )
                        )
                    );
                    return;
                }
            }

            callback();
        };

        return {
            formCadastroManual: {
                numeroContrato: '',
                cultura: '',
                safra: '',
                volumeContratado: '',
                volumeRecebido: '',
                dataContrato: '',
                fornecedor: null,
                cnpjFornecedor: '',
                segmento: '',
                canal: '',
                regional: '',
                estado: '',
                municipio: '',
                gerenteComercial: '',
                gerenteRegional: '',
                gestorTerritorial: '',
                valorContrato: '',
                condicaoFrete: '',
                dataPagamento: '',
                localCondicaoFrete: '',
                tipoContratoOffline: '',
                eudr: undefined
            },

            formCadastroManualRegras: {
                numeroContrato: [
                    {
                        required: true,
                        validator: validarNumeroContrato,
                        trigger: 'blur'
                    }
                ],
                cultura: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                safra: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                volumeContratado: [
                    {
                        required: true,
                        validator: validarVolumeContratado,
                        trigger: 'blur'
                    }
                ],
                volumeRecebido: [
                    {
                        required: false,
                        validator: validarVolumeRecebido,
                        trigger: 'blur'
                    }
                ],
                dataContrato: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                fornecedor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                cnpjFornecedor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                segmento: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                canal: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                regional: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                estado: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                municipio: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                gerenteComercial: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                gerenteRegional: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                eudr: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.error.campoEudr'
                        ),
                        trigger: 'change'
                    }
                ],
                gestorTerritorial: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                tipoContratoOffline: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                valorContrato: [
                    {
                        required: false,
                        validator: validarValorContrato,
                        trigger: 'blur'
                    }
                ],
                condicaoFrete: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                dataPagamento: [
                    {
                        required: false,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                localCondicaoFrete: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ]
            },

            opcoes: {
                culturas: [],
                safras: [],
                fornecedores: [],
                cnpjFornecedores: [],
                segmentos: [],
                canais: [],
                regionais: [],
                estados: [],
                municipios: [],
                gerentesRegionais: [],
                gerentesComerciais: [],
                gestoresTerritoriais: [],
                tiposContratoOffline: [],
                eudr: [
                    {
                        nome: this.$t('mensagens.comuns.sim'),
                        id: 1,
                        value: true
                    },
                    {
                        nome: this.$t('mensagens.comuns.nao'),
                        id: 2,
                        value: false
                    }
                ]
            },

            loading: {
                culturas: true,
                safras: true,
                fornecedor: true,
                cnpjFornecedores: true,
                segmentos: true,
                canais: true,
                regionais: true,
                estados: true,
                municipios: true,
                gerentesRegionais: true,
                gerentesComerciais: true,
                gestoresTerritoriais: true,
                tiposContratoOffline: true
            },

            tipoPessoa: {
                GERENTE_REGIONAL: 'gerentesRegionais',
                GERENTE_COMERCIAL: 'gerentesComerciais',
                GERENTE_TERRITORIAL: 'gestoresTerritoriais'
            },

            adicionandoContrato: false,

            ambientes: AmbientesEmpresas,

            pickerOptionsDataContrato: {
                disabledDate: date => date > new Date()
            }
        };
    },

    mounted() {
        this.buscarCulturas();
        this.buscarSafras();
        this.buscarFornecedores();
        this.buscarSegmentos();
        this.buscarCanais();
        this.buscarRegionais();
        // this.buscarEstados();
        this.buscarLocalidadeNivelUm();
        this.buscarPessoas('GERENTE_REGIONAL');
        this.buscarPessoas('GERENTE_COMERCIAL');
        this.buscarPessoas('GERENTE_TERRITORIAL');
        this.buscarTiposContrato();
    },

    methods: {
        async buscarCulturas() {
            try {
                this.loading.culturas = true;
                const { data } =
                    await ContratoOriginacaoService.buscarCulturas();

                this.opcoes.culturas = data;
                this.loading.culturas = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCultura'
                    )
                );
            }
        },

        async buscarSafras() {
            try {
                this.loading.safras = true;
                const { data } = await ContratoOriginacaoService.buscarSafras();

                this.opcoes.safras = data;
                this.loading.safras = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSafra'
                    )
                );
            }
        },

        async buscarFornecedores() {
            try {
                this.loading.fornecedor = true;
                const { data } =
                    await ContratoOriginacaoService.buscarBpClientes();

                this.opcoes.fornecedores = data;
                this.loading.fornecedor = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarFornecedor'
                    )
                );
            }
        },

        async buscarSegmentos() {
            try {
                this.loading.segmentos = true;
                const { data } =
                    await ContratoOriginacaoService.buscarSegmentos();

                this.opcoes.segmentos = data;
                this.loading.segmentos = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSegmento'
                    )
                );
            }
        },

        async buscarCanais() {
            try {
                this.loading.canais = true;
                const { data } = await ContratoOriginacaoService.buscarCanais();

                this.opcoes.canais = data;
                this.loading.canais = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCanal'
                    )
                );
            }
        },

        async buscarRegionais() {
            try {
                this.loading.regionais = true;
                const { data } = await RegionalService.buscarRegionais();

                this.opcoes.regionais = data;
                this.loading.regionais = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarRegional'
                    )
                );
            }
        },

        async buscarEstados() {
            try {
                this.loading.estados = true;
                const { data } = await LocalidadeService.findEstados(false);

                this.opcoes.estados = data;
                this.loading.estados = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarEstados'
                    )
                );
            }
        },

        async buscarLocalidadeNivelUm() {
            try {
                this.loading.estados = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();
                this.opcoes.estados = data;
                this.loading.estados = false;
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarEstados'
                    )
                );
            }
        },

        async buscarLocalidadeNivelDois() {
            this.formCadastroManual.municipio = '';

            if (!this.formCadastroManual.estado) return;

            try {
                this.loading.municipios = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(
                        this.formCadastroManual.estado,
                        false
                    );

                this.opcoes.municipios = data;
                this.loading.municipios = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarMunicipios'
                    )
                );
            }
        },

        buscarTiposContrato() {
            this.opcoes.tiposContratoOffline = ['Online', 'Offline'];
            this.loading.tiposContratoOffline = false;
        },

        async buscarPessoas(codigoTipoPessoa) {
            try {
                const tipoPessoa = this.tipoPessoa[codigoTipoPessoa];

                this.loading[tipoPessoa] = true;

                const { data } = await PessoaService.buscarPessoa(
                    codigoTipoPessoa
                );
                this.opcoes[tipoPessoa] = data;

                this.loading[tipoPessoa] = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarGerentes'
                    )
                );
            }
        },

        async definirCnpjFornecedor() {
            this.formCadastroManual.cnpjFornecedor = '';
            this.$refs['formCadastroManualRef'].fields
                .find(f => f.labelFor === 'cnpjFornecedor')
                .resetField();
            if (this.formCadastroManual.fornecedor) {
                this.opcoes.cnpjFornecedores =
                    this.formCadastroManual.fornecedor.cpfCnpj;
            }
        },

        adicionar() {
            this.$refs['formCadastroManualRef'].validate(valid => {
                if (valid) {
                    this.adicionandoContrato = true;

                    if (
                        typeof this.formCadastroManual.numeroContrato ===
                            'string' &&
                        this.formCadastroManual.numeroContrato.indexOf('-') !==
                            -1
                    ) {
                        this.formCadastroManual.numeroContrato =
                            this.formCadastroManual.numeroContrato.replace(
                                '-',
                                ''
                            );
                    }

                    ContratoOriginacaoServiceEmpresa.cadastrarManualmente({
                        numeroContrato: this.confereFormatacao(
                            this.formCadastroManual.numeroContrato
                        ),
                        idMaterial: this.formCadastroManual.cultura,
                        idSafra: this.formCadastroManual.safra,
                        volumeContratado: parseFloat(
                            this.formCadastroManual.volumeContratado.replace(
                                ',',
                                '.'
                            )
                        ),
                        volumeRecebido: parseFloat(
                            this.formCadastroManual.volumeRecebido.replace(
                                ',',
                                '.'
                            )
                        ),
                        valorDataContrato:
                            this.formCadastroManual.dataContrato.getTime(),
                        idBpCliente: this.formCadastroManual.fornecedor.id,
                        idSubEmpresa:
                            this.formCadastroManual.fornecedor.idEmpresa,
                        subEmpresaCnpj: this.formCadastroManual.cnpjFornecedor,
                        idSegmento: this.formCadastroManual.segmento,
                        idCanal: this.formCadastroManual.canal,
                        idRegional: this.formCadastroManual.regional,
                        idMunicipio: this.formCadastroManual.municipio,
                        idLocalidade: this.formCadastroManual.municipio,
                        idGerenteComercial:
                            this.formCadastroManual.gerenteComercial,
                        idGestorTerritorial:
                            this.formCadastroManual.gestorTerritorial,
                        idGerenteRegional:
                            this.formCadastroManual.gerenteRegional,
                        valorContrato: parseFloat(
                            this.formCadastroManual.valorContrato
                        ),
                        condicaoFrete: this.formCadastroManual.condicaoFrete,
                        valorDataPagamento: this.formCadastroManual
                            .dataPagamento
                            ? this.formCadastroManual.dataPagamento.getTime()
                            : '',
                        localCondicaoFrete:
                            this.formCadastroManual.localCondicaoFrete,
                        tipoContratoOffline:
                            this.formCadastroManual.tipoContratoOffline ===
                            'Offline',
                        eudr: this.formCadastroManual.eudr
                    })
                        .then(() => {
                            this.$notify.success(
                                this.$t(
                                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contrato'
                                ) +
                                    ' ' +
                                    this.formCadastroManual.numeroContrato +
                                    ' ' +
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contratoInserido'
                                    )
                            );

                            this.$emit('contrato-inserido');
                            this.limpar();
                        })
                        .catch(erro => {
                            const errorData = erro.response.data;
                            const mensagens = errorData.data.map(e => e.messageError).join(', ');

                            this.$notify.error({
                                message: mensagens
                            });
                        })
                        .finally(() => (this.adicionandoContrato = false));
                } else {
                    this.$notify.warning(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoTodosCampos'
                        )
                    );
                    return false;
                }
            });
        },

        limpar() {
            this.$refs['formCadastroManualRef'].resetFields();
        },

        formatarNumeroCofco(numero) {
            const apenasNumeros = numero.replace(/\D/g, '');
            if (apenasNumeros.length === 10) {
                return apenasNumeros.replace(/^(\d{7})(\d{3})$/, '$1-$2');
            } else if (apenasNumeros.length === 11) {
                return apenasNumeros;
            } else {
                return numero;
            }
        },

        formatarNumeroContrato(valor) {
            let novoValor = valor.replace(/\D/g, '');

            if (this.getTrading === 'VITERRA') {
                novoValor = novoValor.slice(0, 12);
            }

            if (this.getTrading === 'COFCO') {
                novoValor = novoValor.slice(0, 11);
                novoValor = this.formatarNumeroCofco(novoValor);
            }

            if (this.getTrading === 'BUNGE') {
                novoValor = novoValor.slice(0, 10);
            }

            this.formCadastroManual.numeroContrato = novoValor;
        },

        confereFormatacao(valor) {
            return valor.includes('-') ? valor.replace('-', '') : valor;
        },

        limparNumeroContrato(valor) {
            const somenteNumeros = valor.replace(/\D/g, '');
            this.formCadastroManual.numeroContrato = somenteNumeros;
        }
    }
};
</script>

<style lang="scss">
#empresa-bloco-inserir-contrato-originacao-manualmente {
    .el-icon-arrow-right:before {
        content: '\E7A0';
        font-size: 24px;
        padding: 10px;
        color: var(--primary);
    }

    h2.cadastro-contrato-originacao__subtitulo {
        font-size: 16px;
        font-weight: bold;

        margin-bottom: 0px;
        margin-left: 20px;
    }

    .el-card {
        border: none;
    }

    .el-collapse-item {
        border-radius: 10px;
        overflow: hidden;
    }

    .el-collapse-item__content {
        padding: 0px;
    }

    .el-form-item {
        padding: 0 4px;
    }

    .el-select,
    .el-input,
    .el-date-picker,
    .el-button {
        width: 100%;
    }

    .row {
        align-items: flex-end;
        margin-bottom: 15px;
    }

    .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label::before,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before {
        content: none !important;
        margin-right: 0px !important;
    }

    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:after {
        content: '*';
        color: #f56c6c;
        margin-left: 4px;
    }

    .botao-submit {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
